package org.multiplatform.kotfolio.models

import org.multiplatform.kotfolio.util.Constants
import org.multiplatform.kotfolio.util.Coroutines
import org.multiplatform.kotfolio.util.Flutter
import org.multiplatform.kotfolio.util.JetpackCompose
import org.multiplatform.kotfolio.util.KMM
import org.multiplatform.kotfolio.util.Kids
import org.multiplatform.kotfolio.util.Kids.RideToRider
import org.multiplatform.kotfolio.util.Kids.TestPaper
import org.multiplatform.kotfolio.util.Kotlin
import kotlin.collections.listOf

enum class BlogEnum(
    val description: String,
    val tags: List<String> = emptyList(),
    val linkTags: List<Pair<String, String>> = emptyList(),
    val bulletPoints: List<String> = emptyList(),
    val fromTo: String
) {
    //Android Studio
    GradleAndroidStudio(
        fromTo = "5-Jun-2026 - 15-Jul-2026",
        description = "Gradle is a build automation tool. Its job is to take your source code and turn it into a final output — an APK for Android, a JAR for a library, or an executable for a backend service.",
        tags = buildList { listOf("Gradle", "Phase", "toml file", "Gradle Plugin", "Compiler Plugin", "maven Authentication", "gradle.properties") },
        bulletPoints = buildList { listOf("Gradle (Phase, settings file, build.gradle (project root), Gradle Plugin, Gradle Catalog sections, toml file), gradle.properties") }
    ),

    //JAVA
    InheritanceJava(
        fromTo = "20-May-2026",
        description = "Inheritance is the process by which object of one class acquires (copying) the properties of another class. Explain types of inheritance, rules, is - A, relationship and method overriding.",
        tags = buildList
        {
            listOf("Inheritance", "sub class", "super class", "IS-A", "Inheritance Type", "Method Overriding")
        },
        bulletPoints = buildList
        {
            listOf("Inheritance - (Subclass, Important Points, IS-A relationship)", "Inheritance Type - (Single Inheritance, Multiple Inheritance, Multilevel Inheritance, Hierarchical Inheritance)", "Method Overriding (Advantage, Rules)")
        }
    ),

    AbstractClassJava(
        fromTo = "20-May-2026",
        description = "An abstract class can have abstract and non-abstract (concrete) methods and can't be instantiated.",
        tags = listOf("Abstraction", "achieve", "Advantage", "Method"),
        bulletPoints = listOf("Abstraction, Ways to achieve Abstraction, Abstraction Advantage, Use", "Abstract class and method rules", "Understanding the real scenario of abstract class")
    ),

    MultithreadingJava(
        fromTo = "20-May-2026",
        description = "Explain the deep Thread, Lifecycle of Thread, Create Thread, Thread Scheduler, ThreadGroup and Shutdown Hook etc.",
        tags = listOf("Multithreading", "Multitasking", "Thread", "main thread", "currentThread"),
        bulletPoints = listOf("Multitasking - (Multitasking can be achieved by 2 ways)", "Thread Types - (User thread, Daemon thread)", "Advantages of Multithreading", "Life cycle Thread (Thread States) - (Newborn State, Runnable State (start()), Running State, Blocked State, Dead State)")
    ),

    DifferenceJava(
        fromTo = "20-May-2026",
        description = "Difference Basic language, Data types, Method (overloading, overriding), Inheritance, Abstract class, Keyword, Thread, Exception Handling, Collection framework etc.",
        tags = listOf("Java", "C", "C++", "JavaScript", "Pass By Value", "Pass By Reference"),
        bulletPoints = listOf("Java Vs C", "Pass By Value Vs Pass By Reference", "Hash Map Vs Hash Set", "Process Based Multi - tasking Vs Thread Based - tasking", "Inheritance Vs Abstract class")
    ),

    //Kotlin
    DesignPatternKotlin(
        fromTo = "22-May-2026",
        description = "Design patterns are reusable solutions to common problems in software design, helping developers build scalable, maintainable, and flexible code. Here’s an exploration of five popular design patterns implemented.",
        bulletPoints = listOf("Singleton Pattern, Factory Pattern, Observer Pattern, Strategy Pattern, Builder Pattern")
    ),

    QuestionsKotlin(
        fromTo = "22-May-2026 - 15-Jul-2026",
        description = "Basic, Keyword, Object oriented programming, null safety, annotations, advance concept, programming question etc.",
        tags = listOf("SOLID Principles", "lambda", "OOP", "interfaces", "Keyword", "Context", "Copy", "val change value", "modifiers", "block", "scope functions", "Interpolation", "Smart Casts", "UTC", "operator (==, ===)", "Initialization", "Distance - (KM, Meters)"),
        bulletPoints = listOf("Interface - (Functional (SAM) interfaces, Interface Segregation Principle (ISP))", "Composition, Aggregation, and Association", "Context Receivers", "Copy - (Shallow Copy - new wrapper, same nested references, Deep Copy - new wrapper and new nested objects)", "modifiers - (public, private, protected, internal, default)")
    ),

    HOFKotlin(
        fromTo = "22-May-2026 - 14-Sep-2026",
        description = "Higher-Order Function is any function that either accepts another function body as a parameter or returns a function body. If it does at least one of these (or both), it earns the title of Higher-Order.",
        tags = listOf("Anonymous", "References", "Infix", "inner", "inline", "crossinline"),
        bulletPoints = listOf("Assigning Functions to Variables (Lambda Expressions)", "Anonymous Functions", "Object Expressions", "Callable References / Function References and Execution", "Functional Parameters with Receivers", "Infix Higher - Order Functions", "inner class", "Inline (keyword, Function) - (No lambda object, No invoke() call, No function call)", "Why do we need inline functions?", "noinline - (lambda object)", "crossinline - (safe control flow)")
    ),

   FilterCollectionKotlin(
        fromTo = "22-May-2026 - 24-Jun-2026",
        description = "first(), firstOrNull(), singleOrNull(), mapOf(), map(), associateBy(), associateWith(), associate(), flatMap(), flatten(), distinct(), groupBy(), sortedBy(), sortedByDescending(), sortedWith(), scan(), scanReduce(), Collection builders(), filter(), filterNot(), filterIndexed(), filterIsInstance(), filterNotNull(), mapNotNull(), chunked(), windowed(), partition(), cantChangeList(), getOrNull(), getValue(), getOrDefault(), getOrElse(), binarySearch(), binarySearchBy(), binarySearch(), binarySearchBy(), distinct(), set(), any(), none(), all(), zipWithNext(), intersect(), runningFold(), coerceAtLeast(minValue), coerceIn(minValue, maxValue), coerceAtMax, coerceAtMost(maxValue), elementAt(), elementAtOrElse(), elementAtOrNull(), sumOf(), maxByOrNull(), minByOrNull(), toInt(), toIntOrNull(), takeUnless(), takeIf()"
     ),

    RaceConditionKotlin(
        fromTo = "22-May-2026 - 6-Jun-2026",
        description = "Mutex in Kotlin is a powerful tool for coroutine synchronization, offering non-blocking, suspension-friendly locks. It’s ideal for use cases where shared resources are accessed concurrently by coroutines. By using methods like lock, unlock, and withLock, Kotlin provides safe and efficient ways to manage critical sections in your coroutines-based applications.",
        tags = listOf("Volatile", "atomic", "synchronized", "Mutex", "Work"),
        bulletPoints = listOf("Race condition - (Volatile, atomic, synchronized)", "Mutex - (Characteristics, Method, How It Works)")
    ),

    NewFeatureKotlin(
        fromTo = "22-May-2026 - 4-Jun-2026",
        description = "In Kotlin 2.0.0, the new Kotlin K2 compiler is used by default and it is Stable for all target platforms: JVM, Native, Wasm, and JS",
        linkTags = listOf(
             "2.0" to Kotlin.KotlinNewFeature.NEW_FEATURE_URL,
             "2.0.20" to Kotlin.KotlinNewFeature.NEW_FEATURE_2_0_20_URL,
             "2.1.0" to Kotlin.KotlinNewFeature.NEW_FEATURE_2_1_0_URL,
             "2.2.0" to Kotlin.KotlinNewFeature.NEW_FEATURE_2_2_0_URL,
             "2.3.0" to Kotlin.KotlinNewFeature.NEW_FEATURE_2_3_0_URL,
             "2.3.20" to Kotlin.KotlinNewFeature.NEW_FEATURE_2_3_20_URL,
             "2.4.0" to Kotlin.KotlinNewFeature.NEW_FEATURE_2_4_0_URL,
             "2.5.0 Beta1" to Kotlin.KotlinNewFeature.NEW_FEATURE_2_5_0_BETA_1_URL
        )
    ),

    //Kotlin Notebook
    NotebookKotlin(
        fromTo = "23-May-2026",
        description = "Kotlin Notebook is a dynamic plugin for IntelliJ IDEA that provides an interactive environment to create and edit notebooks, leveraging the full potential of Kotlin's capabilities.",
        bulletPoints = listOf("KTOR API Calling", "Add Dependencies", "JSON print", "Chart", "dataframe")
    ),

    //Coroutines
    BasicCoroutines(
        fromTo = "20-May-2026",
        description = "Coroutines execute long-running tasks without blocking the main thread or freezing the UI.",
        tags = listOf("Coroutines", "Concurrency", "Mutex", "Semaphore", "Asynchronous", "Synchronous", "Structured Concurrency", "Coroutines work", "Thread"),
        bulletPoints = listOf("Coroutines", "Concurrency vs. Parallelism on Dispatchers", "Concurrency, Semaphore, Mutex, Semaphore, Asynchronous, Synchronous, Structured Concurrency - (Advantage)")
    ),

    SuspendingFunctionsCoroutines(
        fromTo = "20-May-2026 - 15-Jul-2026",
        description = "Suspending functions are special functions that perform asynchronous operations. Coroutine Builder (runBlocking, launch, async), Kotlin offers a variety of functions you can use to create coroutines.",
        tags = listOf("Blocking", "Suspending()", "Suspend() Work", "Switching Thread", "Continuations"),
        bulletPoints = listOf("Suspend - (Suspend() Work, Suspend() Work internally, Suspension and Resumption work internally, Call suspend() from another suspend(), suspend() different from a regular async call, suspend vs blocking, Suspending() - (delay(timeMillis: Long), yield(), withContext(context: CoroutineContext), withTimeout(timeMillis: Long), withTimeoutOrNull(timeMillis: Long), Coarse Whole Request Deadline, awaitAll(), joinAll(vararg jobs: Job),))", "Continuations - (Work)", "Coroutine Builder - (runBlocking, withContext, withContext(NonCancellable), produce, actor)",  "CoroutineScope (Global scope, ViewModel scope, Lifecycle scope, viewModelScope, Main scope, CoroutineScope)" , "Coroutine Builders - (launch, async, runBlocking - (withContext))")
    ),

    DispatchersCoroutines(
        fromTo = "20-May-2026 - 14-Oct-2026",
        description = "Dispatchers help determine the thread on which a coroutine task should be executed. (EmptyCoroutineContext, Dispatchers.Default, Dispatcher.IO, Dispatchers.Main, Dispatchers.Unconfined). Switching Between Threads Using Dispatchers and Automatically Coroutines Cancellation (yield(), isActive() and ensureActive()).",
        tags = listOf("Dispatchers", "Dispatchers Work Internally", "Custom Dispatchers", "𝗖𝗼𝗿𝗼𝘂𝘁𝗶𝗻𝗲𝘀 𝗖𝗮𝗻𝗰𝗲𝗹𝗹𝗮𝘁𝗶𝗼𝗻"),
        bulletPoints = listOf("Dispatchers.Default", "Dispatcher.IO", "Dispatchers.IO.limitedParallelism", "Dispatchers.Swing", "Dispatchers.Main", "Dispatcher.Main.immediate", "Dispatchers.Unconfined", "Custom Dispatchers", "Switching Between Threads Using Dispatchers - (withContext for Thread Switching, async-await for Concurrent Operations, Ensure Main Dispatcher for UI Updates, Combining Dispatchers for Complex Scenarios)", "Thread.currentThread()", "𝗖𝗼𝗿𝗼𝘂𝘁𝗶𝗻𝗲𝘀 𝗖𝗮𝗻𝗰𝗲𝗹𝗹𝗮𝘁𝗶𝗼𝗻 - (yield(), isActive(), ensureActive())")
    ),

    FlowBasicCoroutines(
        fromTo = "21-May-2026 - 14-Oct-2026",
        description = "Flow, Flow work, Upstream and DownStream, lifecycleScope, Flow Builders, Cancel Flow, callbackFlow and flowOn Operator etc",
        tags = listOf("Flow", "Flow Work", "Default Flow", "Cold flow and Hot flow", "Lifecycle-Aware", "LifecycleScope", "Flow Create", "Flow Builders", "flowOn", "Flow Combine", "Filter / Search"),
        linkTags = listOf(
            "Flow Basic" to Coroutines.FLOW_BASIC_URL,
            "Flow Create" to Coroutines.FLOW_CREATE_URL,
            "Flow Builders & Flow Exception Handling" to Coroutines.FLOW_BUILDERS_URL,
            "FlowOn() Operators" to Coroutines.FLOW_ON_URL,
            "Combine Flow (Category Wise Selection)" to Coroutines.FLOW_COMBINE_URL,
            "Combine, Zip, filter Programmatically" to Coroutines.FILTER_URL
        ),
        bulletPoints = listOf("Flow Basic - (Use Flow, Pros, Flow Work), Why needs flow?, When does a flow run, By default Flow will execute, Flow introduction, Upstream and DownStream, Flow emit value, Cold flow and Hot flow, Are Flows lifecycle-aware?", "LifecycleScope (Lifecycle-aware manner)", "why use Flow instead of ChannelFlow by default?", "Flow Create - (Flow are categorised into two types (Intermediate operators, Terminal operators), flow(), flowOf(), asFlow(), asStateFlow(), asSharedFlow(), emptyFlow(), channelFlow(), callbackFlow)", "Flow Combine (zip(), combine())", "Filter/Search")
    ),

    StateSharedFlowCoroutines(
        fromTo = "20-May-2026 - 7-Jul-2026",
        description = "StateFlow, Why use StateFlow, Lifecycle of StateFlow, SharedFlow, SharedFlow properties.",
        tags = listOf("StateFlow", "SharedFlow", "Features StateFlow", "Benefits", "Backpressure", "SharedFlow work", "Combining"),
        bulletPoints = listOf("StateFlow - (Hot Flow - Structured concurrency, Multiple collectors, Initial value, Key Features of StateFlow, Benefits of StateFlow), Lifecycle of StateFlow, Backpressure Handling in StateFlow", "What makes StateFlow different from Flow?", "SharedFlow - (event-based flow with no persistent state, Key Features of SharedFlow, SharedFlow work, Use SharedFlow)", "Difference between “replay” and “extraBufferCapacity” in Kotlin MutableSharedFlow", "Combining Coroutines with SharedFlow and StateFlow")
    ),

    StateShareInCoroutines(
        fromTo = "20-May-2026",
        description = "stateIn and shareIn are functions that are used to convert a cold Flow into a hot Shared Flow.",
        tags = listOf("stateIn", "shareIn", "SharingStarted types", "Convert Flow"),
        bulletPoints = listOf("stateIn (stateIn Works, When to use stateIn)", "shareIn - (SharingStarted types, When to use sharedIn)", "Converting a flow from Cold to Hot")
    ),

    ScopeCoroutines(
        fromTo = "20-May-2026 - 15-Jul-2026",
        description = "Why Use Scopes, Coroutine Scope, Supervisor Scope, Coroutine context, Job, Coroutines exception handle.",
        tags = listOf("Scopes", "CoroutineContext (Dispatcher, Job, Error handler (CoroutineExceptionHandler), CoroutineName, CoroutineScope)", "Job"),
        bulletPoints = listOf("Why Use Scopes - (GlobalScope (not recommended), Coroutine Scope, coroutineScope - Propagating Failures to All Children, Supervisor Scope - Fail Independently (If one child fails, others continue unaffected), supervisorScope - Real-World Analogy: Rajasthan's Water Management System)", "CoroutineContext - (Characteristics, How to CoroutineContext, CoroutineContext.Element), Job - (Type of Jobs - (Job, SupervisorJob), Actions with Job - (Checking State, Cancellation, Dependency Management) Job States - (New, Active, Completing, join, Cancelled))", "Deferred Job and How it pass the result to parent Coroutine", "Job vs Deferred(async)", "CoroutineExceptionHandler (Cancelling Coroutines) (Handling Exception)", "How Does Cancellation Work?", "combine multiple context + symbol"),
        linkTags = listOf(
             "Coroutine Context | Coroutine Cancellation" to Coroutines.CONTEXT_CANCELLATION_URL,
             "suspendCoroutine | suspendCancellableCoroutine | Exception Handling (Throw, resumeWithException) | Callback (resumeWithException)" to Coroutines.SUSPEND_URL,
             "Channel Communication's Coroutines" to Coroutines.CHANNEL_URL
         ),
    ),

    SemaphoreCoroutines(
        fromTo = "28-May-2026",
        description = "Semaphore is a technique by which concurrent processes or operations are managed using an integer value. It takes care of concurrent operations made to the common resources across multiple threads to achieve process synchronization.",
        bulletPoints = emptyList()
    ),

    QuestionsCoroutines(
        fromTo = "20-May-2026",
        description = "Coroutines questions are Basic, Top Questions, Long-running coroutines, Thread, Concurrency, Reactive Programming, Flow, suspend etc.",
        linkTags = listOf(
            "Single Question - 53" to Coroutines.SINGLE_QUESTIONS_URL
        ),
        bulletPoints = emptyList()
    ),


    //FLUTTER
    BasicFlutter(
      fromTo = "20-May-2026",
      description = "Architecture, Rendering Tree, setState() and internal process\", \"Explain the deep Flutter architecture, BuildContext, Rendering tree and How to work setState() internal and performance benefits",
      tags = listOf("skia", "Impeller", "Flutter architecture", "BuildContext", "RenderObject", "Relationship", "Element Tree", "Render Tree", "State", "Widget rebuild", "Benefits"),
      bulletPoints = listOf("Skia (Old), Impeller (New)", "Flutter architecture (Upper layers, Engine Layer, Built-in service, Platform Layer)", "BuildContext (Important, Connecting Widgets)", "RenderObject - Every widget in Flutter has a drawing on the screen via a need called RenderObject. This is the one that deals with painting, moving widgets, and hit testing.", "Relationship Between Widgets, BuildContext, and RenderObject", "Element Tree - Middle of Widgets and RenderObjects sits Elements.", "Render Tree", "Widget Tree", "state, Types of state", "SetState(), context.mounted(), markNeedsBuild()")
    ),

    MainWidgetFlutter(
        fromTo = "20-May-2026",
        description = "Stateless widget and Stateful widget lifecycle createState(), mounted(), initState(), didChangeDependencies(), build(), didUpdateWidget(), setState(), deactivate() and dispose(), state, Mutable State and Dispose() vs Deactivate().",
        tags = listOf("Stateless", "Stateful", "Widgets Lifecycle", "Mounted", "AppLifecycleListener"),
        bulletPoints = listOf("Widget (Stateless, Stateful)", "Stateful widgets lifecycle - (createState(), initState(), mounted(), didChangeDependencies(), build(), didUpdateWidget(), setState(), deactivate(), dispose(), reassemble())", "Dispose() vs Deactivate()", "Mounted", "AppLifecycleListener"),
        linkTags = listOf(
            "NULL Aware Operator" to Flutter.NULL_SAFETY_DART_URL
        )
    ),

    CleanArchitectureFlutter(
        fromTo = "20-May-2026",
        description = "Introduction of MVC (Model, View, Controller), MVP (Model, View, Presenter), MVVM (Model, View, View model) and Clean architecture (Data layer, Domain layer, Presentation layer). Clean architecture using BLoC application use the library Cubit, go router, change theme, language translation, freezed, equatable and auto mapper.",
        tags = listOf("Clean Architecture", "Data Layer", "Domain Layer", "Presentation", "typedef", "Step", "Mapping"),
        bulletPoints = listOf("Low-Level Design (LLD)", "MVC (Model View Controller)", "MVP (Model View Presenter)", "Clean Architecture (CA), Components of Clean Architecture", "Mapping, Entity", "Data Layer", "Domain Layer, Domain layer completely independent", "Presentation Layer", "UseCase, Single Responsibility, Independent, Entities, Repositories, Interface adapters (controllers, viewmodels, interactors, presenters)", "typedef, Comment style, Step clean architecture"),
        linkTags = listOf(
            "SOLID Principles" to Flutter.SOLID_PRINCIPLES_URL
        )
    ),

    BLoCStateManagementFlutter(
        fromTo = "20-May-2026 - 6-Jun-2026",
        description = "BLoC (Business Logic Component) is a popular architectural pattern in the Flutter. A family of stream/observable-based patterns.",
        tags = listOf("BLoC", "Features", "Work", "Choose", "azy Loading", "Cubit"),
        bulletPoints = listOf("BLoC (Features, Advantages, choose BLoC, BLoC Architecture, Bloc Work, flutter_bloc context, BlocProvider, restartable, MultiBlocProvider, BLocObserver), Bloc Create (Bloc Initialization), BLoC Lazy Loading, BlocBuilder, BlocListener, MultiBlocListener, BLoC Consumer, Bloc Selector, MultiRepositoryProvider, listenWhen and buildWhen, when vs whenOrNull", "Cubit - (Transformers BLoC),", "BLoC Vs Cubit, BLoC Vs GetX, BLoC Vs Riverpod")
    ),

    RiverPodManagementFlutter(
        fromTo = "20-May-2026",
        description = "Riverpod is popular state management pattern. It is Reactive Caching and Data-binding Framework. It is Declarative programming, Easily implement common UI patterns, Compile safety, Custom lint rules, Native network requests support, Websocket support etc."
    ),

    GetXStateManagementFlutter(
        fromTo = "20-May-2026",
        description = "GetX is designed to be fast, lightweight, high-performance and reactive state management approach.",
        tags = listOf("GetX", "Advantages", "2 different approaches", "Route (Routing)", "Validation", "Internationalization", "Bindings"),
        bulletPoints = listOf("GetX, Advantages, Builder - (Obx(), GetX(), GetBuilder())", "Route (Routing) Management", "Parameter Argument", "Snackbar, Dialog, Toast, and Sheets", "Dependency Injection - (Get.create(), Get.put(), Get.lazyPut(), Get.find(), Get.putAsync(),  Get.lazyPutAsync(), Get.putAsync())", "Validation", "Internationalization (i18n)", "Bindings", "GetxService")
    ),

    DependencyInjectionFlutter(
        fromTo = "20-May-2026",
        description = "Dependency injection is a software design pattern that deals with the management and injection of dependencies into a class or module from the outside.",
        tags = listOf("Dependency", "Injection", "Inversion"),
        bulletPoints = listOf("Why do we need Dependency Injection?", "Dependency Inversion", "Types of Dependency Injection", "Get_It - (Register Singleton, Register Lazy Singleton, Register Factory, async support)")
    ),

    FreezedAnnotationFlutter(
        fromTo = "20-May-2026",
        description = "Annotations for the freezed code-generator, Dart classes automatically generates code for converting to and from JSON. The JsonSerializable annotation will generate code for a class to/from JSON.",
        tags = listOf("Approach", "annotations", "linter"),
        bulletPoints = listOf("Traditional Approach", "freezed annotations", "Key Features", "Assertions", "Sealed class", "Linter rules")
    ),

    AsynchronousFlutter(
        fromTo = "20-May-2026",
        description = "future, stream (Types of Stream, Sink, EventSink, StreamController, StreamSubscription), async, async*, await, FutureBuilder, StreamBuilder, Uncompleted vs Completed",
        tags = listOf("Asynchronous", "Thread", "Future", "Async and Await", "Stream", "async*"),
        bulletPoints = listOf("Asynchronous, Synchronous, Thread, Future, Async and Await, FutureBuilder, Stream, Stream Manage, Types of Stream, Stream builder, Stream Error Handling, async vs async*")
    ),

    IsolateFlutter(
        fromTo = "20-May-2026",
        description = "Isolates are a way to run Dart code in a separate thread, allowing developers to perform concurrent operations without blocking the main UI thread. Isolates vs. Threads. Types of isolate.",
        tags = listOf("Isolate", "Event loop", "Event queue", "Types"),
        bulletPoints = listOf("Isolate, Isolates Necessary, Event loop & Event queue, Isolate communication, Why Use Isolates", "2 ways to create isolate - (Isolate.run, Isolate.spam)")
    ),

    ChannelCommunicationFlutter(
        fromTo = "20-May-2026",
        description = "Platform channels are essentially a communication channel that allows your Flutter code to interact with native code written in Java/Kotlin (Android) or Swift/Objective-C (iOS).",
        tags = listOf("Platform Channels", "Method Channel", "Event Channel"),
        bulletPoints = listOf("Platform Channels", "Method Channel (Work)", "EventChannel (Work)")
    ),

    QuestionsFlutter(
        fromTo = "20-May-2026",
        description = "Dart interview questions likes Basic, OOP, AOT, JIT, Keyword, Sealed class, Typedef, Record and Dart 3.",
        tags = listOf("Dart", "Flutter", "AOT", " Null Aware Operator", " Lazy Loading", "singleton", "Factory", "AutomaticKeepAliveClientMixin", "Mixins", "Records", "RepaintBoundary", "LookupBoundary"),
        bulletPoints = emptyList()
    ),

    //JetpackCompose
    BasicJC(
        fromTo = "20-May-2026 - 24-Jun-2026",
        description = "Jetpack Compose UI toolkit uses a declarative programming model to define UI components.",
        tags = listOf("Skipping", "New Feature", "ComponentActivity", "Context", "LocalContext", "LocalActivity", "Layout Inspector", "Track Recompositions", "TOML", "Arrow Library", "Declarative - Imperative UI", "Annotation", "FIR", "IR", "Slot Table", "layoutInfo", "movableContentOf", "Retained"),
        bulletPoints = listOf("Skipping Mode", "Compose Prototyping in Kotlin Notebooks", "Optimize Imports - (Validation, Password encode, R. String 35 or Higher, font, archivesBaseName, buildkonfig, Remove Cache Free Space, buildConfigField constants, buildConfigField dynamic, Improve app performance with optimized resource shrinking, builder, typealias Composable, Custom Actions)", "Annotation, Composer, Slot Pattern, Named Slots for Better Customization, Compose Compiler, Slot Table", "Lazy composition - (Column and LazyColumn (LazyListState Retained, contentType, contentPadding, itemsIndexed, Key), LazyRow (LazyRow Center View Find using layoutInfo), rememberLazyListState, LazyLayoutCacheWindow)", "Viewport-Aware Composition")
    ),

    ModifiersJC(
        fromTo = "20-May-2026 - 30-Jun-2026",
        description = "Modifiers are the fundamental building blocks for customizing and enhancing your composables in Jetpack Compose.",
        tags = listOf("Optimization", "Arrangement", "Condition", "Node", "measuredHeight", "LazyColumn Animation"),
        bulletPoints = listOf("Modifiers Optimization", "Column, Row and Box Arrangement", "Modifiers (graphicsLayer, selectableGroup, Condition -  (if, them. ifNotNull, true/false, FocusTab), Node, Modifiers Parameter Types, Vertical Scrolling - (rememberScrollState(), verticalScroll()), drawBehind, drawWithContent, drawWithContent, drawWithCache, onGloballyPositioned - (Mental Model), IntrinsicSize, defaultMinSize, semantics, Weight Vs Fraction, measuredHeight - (Icon Alignment Center))")
    ),

    ComposeLifeCycleJC(
        fromTo = "2-Jun-2026 - 15-Jul-2026",
        description = "Composable lifecycle consists of three main phases Composition (created), Recomposition (updated) and Disposal (destroyed).",
        tags = listOf("Lifecycle", "Recomposition Work", "Snapshotting Works", "Lambda", "HOF", "Unit()", "Nothing", "Memoization", "typealias", "invoke()", "compose() function types of parameter", ":: callable reference"),
        bulletPoints = listOf("Lifecycle of composable functions or Composition", "Recomposition Work", "Snapshotting Works", "What is recomposition and how does Compose decide what to recompose?", "Recomposition Happen (Occur)", "Lambda Reducing Recomposition Overhead", "SAM Single Abstract Method (Functional Interface)", "High-Order Functions (HOF)", "Lambda-Friendly Functions", "Lambda Memoization", "Unit() - High-Order Functions (HOF)", "Nothing - (Function never returns normally)")
    ),

    DataFlowJC(
        fromTo = "20-May-2026",
        description = "Unidirectional Data Flow (UDF), also known as State Hoisting, lifting state up (data goes down, actions go up) for better reusability and clean architecture.",
        tags = listOf("UDF", "Implementing UDF", "Hoisted"),
        bulletPoints = listOf("Unidirectional data flow (UDF)", "UDF Flow", "Pattern Data flows down, events flow up", "Implementing UDF 3 ways - (State Hoisting, Event Handling, Single Source of Truth)", "Relation between State Hoisting and UDF", "Hoisted Task Input", "Why it doesn’t update the UI?")
    ),

   StateHostingJC(
        fromTo = "20-May-2026",
        description = "State hoisting means that the parent owns the state, and the child only displays it and notifies when it changes. This promotes a more predictable and scalable architecture.",
        tags = listOf("State Hosting", "Hoist/Hoisted State", "Shared State", "Type of state hoisting"),
        bulletPoints = listOf("State Hosting - (When to use this pattern, Safer pattern, When to Use State Hoisting, Hoist/Hoisted State (Shared State))", "How does state hoisting work in Compose and why is it important?", "No state hoisting needed", "Type of state hoisting - (Stateless, Stateful)", "mutable and immutable objects", "How does State differ from a regular variable in Compose?")
    ),

    ScopedSlotsJC(
        fromTo = "20-May-2026 - 17-6-2026",
        description = "Scoped slots refer to content areas in a layout that provide additional, layout-specific capabilities to the composables placed inside them.",
        tags = listOf("Slot", "Scoped", "Custom Column"),
        bulletPoints = listOf("Slot APIs", "Scoped Slots", "Scope (RowScope, ColumnScope, BoxScope, LazyListScope, LazyGridItemScope, DrawScope, AnimatedVisibilityScope)", "Custom Column")
    ),

    InternalRenderProcessJC(
        fromTo = "20-May-2026 - 14-Sep-2026",
        description = "Render compose is a a unidirectional flow that happens from composition to drawing to produce a frame. It manages state, handles smart recomposition, and ensures efficient updates to the UI. The composer injected by the compiler connects composable functions to the Compose Runtime.",
        tags = listOf("Frame", "Render process", "Measurements", "Compose Runtime", "Composition Architecture", "Snapshot System", "Recomposition Pipeline", "Slot Table"),
        linkTags = listOf(
           "Internal Render Process, Composition Phases - (Data, Composition, Layout (measurement, placement), Drawing, UI), SubcomposeLayout, Key Concepts of Measurements, " to JetpackCompose.INTERNAL_RENDER_PROCESS_URL,
           "Compose Runtime" to JetpackCompose.RUNTIME_URL,
           "Composition Architecture - (Slot Table, Snapshot System)" to JetpackCompose.COMPOSITION_ARCHITECTURE_URL),
        bulletPoints = listOf("Main phases of a frame", "Layout System (Measure, Layout, Draw)", "Render process of compose / Main phases Composition / Compose phases - (Composition, Recomposition, Measure, Layout, Drawing, Rule of thumb for animations)", "What is recomposition, and when does it occur? Also, how does it related to the app performance?", "Measurements - (Layout(content, modifier, measurePolicy), measurables, constraints, measurable.minIntrinsicHeight(width), measurable.measure(constraints.copy(...)), placeable.place(x, y))", "Compose Runtime - (Compose Runtime Work), Composition Architecture", "Slot Table - (gap buffer, How does Slot Table actually store nodes?, Composer, Applier (Ui Node Tree), Runtime work)", "Snapshot System")
    ),

    StateManageJC(
        fromTo = "20-May-2026",
        description = "State in Jetpack Compose represents any data that can change over time and cause UI recomposition. The framework observes changes in state and updates the UI automatically when needed.",
        tags = listOf("Stop Using mutableListOf (Use buildList, buildMap, buildSet)", "Immutable Collections (kotlinx.collections.immutable)", "State Manage", "Lifecycle Awareness", "Kotlin", "narrowest", "non-compose state", "Update UI", "MutableState", "create state object", "mutableStateOf", "Lifecycle-Aware Components", "SnapshotStateList"),
        bulletPoints = listOf("State Manage Compose - 3 way, Lifecycle Awareness(collectAsStateWithLifecycle(), LaunchedEffect(), SideEffect(), DisposableEffect(), Observing Raw Lifecycle States via LocalLifecycleOwner)", "Kotlin - ((Explicit backing fields)", "How to read the state within the narrowest possible range", "State Management - (mutableStateOf, remember)", "How can we convert a non-compose state into a Compose state?", "What is a State, Event and how does compose update UI?", "State Management Techniques - (StateFlow, ViewModel, LiveData, LiveData, remember, State Hoisting, Side effect / Effect Handler, compositionLocal)", "How does State trigger Recomposition in Jetpack Compose?", "collectAsStateWithLifecycle - (collectAsStateWithLifecycle() for Lifecycle-Aware Collection, Features, Use, Work)", "Lifecycle-Aware Components Compose (DefaultLifecycleObserver, @OnLifecycleEvent (Deprecated), collectAsStateWithLifecycle())", "MutableStateFlow Operations - (CURD, Add to Cart logic / Change Quantity, Filter, operator invoke())"),
        linkTags =
            buildList {
                addAll(
                    listOf(
                        "StateFlow & SharedFlow" to Coroutines.STATE_SHARED_FLOW_URL
                    )
                )
            }
    ),

    WrapperStateJC(
        fromTo = "20-May-2026",
        description = "Common wrapper class is Kotlin class. It is used to clean code, wrapper the code easy to handle response success, failed and loading.",
        tags = listOf("PascalCase", "Sandwich"),
        bulletPoints = listOf("PascalCase", "Flow Combine", "@UnsafeVariance", "Sandwich Kotlin", "Multimodule Structure", "Multimodule Structure"),
        linkTags = buildList {
            addAll(listOf(
            "Sandwich" to KMM.KMP.SANDWICH_URL,
        )
            )
        }
    ),

    StabilityJC(
        fromTo = "20-May-2026 - 10-Sep-2026",
        description = "Compose determines the stability of each parameter of your composables to work out if it can be skipped or not during recomposition.",
        tags = listOf("Optimizing Data Models", "Lambda", "ImmutableList", "Stable & Immutable", "Skipped Compositions and Performance Bottlenecks", "Composable not be Skipped"),
        bulletPoints = listOf("Why Optimizing Data Models in Jetpack Compose Matters.", "Stability of the compose compiler", "Massive State Objects", "Lambda Modifier Variants", "ImmutableList - (ImmutableList, persistentListOf(), Shorter form", "Stable - (Trusted between observable changes) & Immutable - (Total trust, always skipped, work)", "ReadOnlyComposable, NonRestartableComposable, PausableComposition", "ConcurrentHashMap Network Connection Check")
    ),

    EffectHandlerJC(
        fromTo = "20-May-2026 - 29-Aug-2026",
        description = "Side effects (Effect Handler) are ways to handle changes outside compose the UI hierarchy that need to be reflected in your Compose functions or to ensure certain actions take place as a result of state changes.",
        linkTags =  buildList {
            addAll(
                listOf(
                    "SideEffect" to JetpackCompose.SideEffect.SIDE_EFFECT_EXTERNAL_URL,
                    "LaunchedEffect" to JetpackCompose.SideEffect.LAUNCHED_EFFECT_URL,
                    "produceState" to JetpackCompose.SideEffect.PRODUCE_STATE_URL,
                    "Remember" to JetpackCompose.SideEffect.REMEMBER_URL,
                    "RememberUpdatedState" to JetpackCompose.SideEffect.REMEMBER_UPDATED_STATE_URL,
                    "RememberCoroutineScope" to JetpackCompose.SideEffect.REMEMBER_COROUTINE_SCOPE_URL,
                    "SaveableStateHolder" to JetpackCompose.SideEffect.SAVEABLE_STATE_HOLDER_URL,
                    "RememberSaveable" to JetpackCompose.SideEffect.REMEMBER_SAVEABLE_URL,
                    "RememberSerializable" to JetpackCompose.SideEffect.REMEMBER_SERIALIZABLE_URL,
                    "RememberObserver" to JetpackCompose.SideEffect.REMEMBER_OBSERVER_URL,
                    "Saver Custom" to JetpackCompose.SideEffect.SAVER_CUSTOM_URL,
                    "retain" to JetpackCompose.SideEffect.RETAIN_URL,
                    "snapshotFlow" to JetpackCompose.SideEffect.SNAPSHOT_FLOW_URL,
                    "derivedStateOf" to JetpackCompose.SideEffect.DERIVED_STATE_OF_URL,
                    "DisposableEffect" to JetpackCompose.SideEffect.DISPOSABLE_EFFECT_URL,
                    "savedState" to JetpackCompose.SideEffect.SAVED_STATE_URL
                )
            )
        },
        bulletPoints = listOf("What is state and how does it relate to Jetpack Compose UI?", "How does state management work in Jetpack Compose?", "Suspend Functions Reusable in Jetpack Compose", "Effect Handler - (SideEffect, LaunchedEffect, produceState, remember, rememberUpdatedState, rememberCoroutineScope, SaveableStateHolder, rememberSaveable, rememberSerializable, Saver Custom, retain, snapshotFlow, derivedStateOf, DisposableEffect)", "savedState")
    ),

    CompositionLocalJC(
        fromTo = "20-May-2026 - 7-Jun-2026",
        description = "Unidirectional Data Flow, Why use CompositionLocal, staticCompositionLocalOf(), compositionLocalOf(), Creating Your Own CompositionLocals.",
        tags = listOf("normal composable", "CompositionLocal", "Benefits", "Local Provider", "CompositionLocal using context"),
        bulletPoints = listOf("A problem in normal composable function tree", "Benefits of CompositionLocal", "How is this better than the static global object?", "Composition Local Provider - Static (staticCompositionLocalOf), Dynamic (compositionLocalOf)", "compositionLocalOf() Vs staticCompositionLocalOf()")
    ),

    ViewModelJC(
        fromTo = "20-May-2026 - 20-Oct-2026",
        description = "The ViewModel class is a business logic or screen level state holder (Reserved for actual business logic). It exposes state to the UI and encapsulates related business logic. Its principal advantage is that it caches state and persists it through configuration changes.",
        tags = buildList {
            listOf(
                "New APIs",
                "rememberViewModelStoreOwner",
                "rememberViewModelStoreProvider",
                "Delegation",
                "ViewModelProvider",
                "ViewModelStoreOwner",
                "Too Many Parameters",
                "Screen-level state holder",
                "Koin Constructor DSL",
                "Common ViewModel",
                "Factory Pattern",
                "One-Time Events"
            )
        },
        bulletPoints =
            buildList {
                listOf(
                    "New APIs close that gap - Stop Building God ViewModels with “One Screen = One ViewModel” - (rememberViewModelStoreOwner, rememberViewModelStoreProvider)",
                    "Delegated State Holders for Compose Features",
                    "How does ViewModel survive configuration changes?",
                    "Does ViewModel survive process death?",
                    "savedStateHandle — Surviving Process Death",
                    "ViewModels EmptyCoroutineContext (Kotlin 2.3.0)",
                    "Initial Load 3 Ways",
                    "ViewModel @Stable Annotation",
                    "ViewModel Argument Pass Parameter (Koin, Multiple ViewModel, metroViewModel))",
                    "Too Many Parameters constructor in viewmodel trap - (Factory Pattern, Koin @Factory)",
                    "Channel for One-Time Events",
                    "Immutable Data + Stable Collections"
                )
            },
        linkTags = buildList {
            listOf(
                "AutoCloseable" to JetpackCompose.VIEWMODEL_AUTO_CLOSEABLE_URL
            )
        }
    ),

    AppStateTransformJC(
        fromTo = "4-Nov-2026",
        description = "AppState Transform is built on the Compose runtime. It allows developers to execute a @Composable block without actually rendering any UI.",
        tags = listOf("Search using Transform", "Transform", "StateStore", "return@transform"),
    ),

    NavigationJC(
        fromTo = "22-May-2026 - 24-Jul-2026",
        description = "Navigation 3 is a new library for Compose, provides full back stack control, adaptive layouts, NavDisplay and implementing NavKey for screens.",
        bulletPoints = emptyList()
    ),

    PaginationJC(
        fromTo = "22-May-2026 - 19-Aug-2026",
        description = "Pagination in Jetpack Compose involves efficiently loading and displaying large datasets in a user interface by fetching data in smaller, manageable chunks rather than all at once.",
        tags = listOf("Number pagination (Desktop, Tablet, Web)", "Paging 3", "Generic Paging"),
        bulletPoints = listOf("PagingSource, RemoteMediator, getRefreshKey(), closestPageToPosition(), LoadResult(), Pager, PagingConfig, pagingSourceFactory, Loading States")
    ),

    AnimationJC(
        fromTo = "22-May-2026 - 19-Sep-2026",
        description = "Animations are essential in a modern mobile app in order to realize a smooth and understandable user experience.",
        tags = listOf("Animatable", "animate*AsState", "animateFloatAsState", "animateDpAsState", "animateColorAsState", "animateIntAsState", "animateSizeAsState", "updateTransition", "AnimatedVisibility", "MutableTransitionState", "AnimatedContent", "Onboarding"),
        bulletPoints = listOf("Types of Animations in Compose - (Animatable, animate*AsState, updateTransition, AnimatedVisibility, AnimatedContent)", "AnimatedContent using API Calling Handle (Error, Loading, Success)", "animate*Asstate - single value, single trigger Useful for color, alpha, trivial offsets.", "Animatable - which is used to interrupt, chain or run imperatively driven animations (gesture driven UI).", "updateTransition — combined properties that need to animate together due to one state change.", "Scroll to Hide Header, Select Date Flip, Chat UI, Animated Tag Scale, Animation for TopBar, Like/Unlike (Follow/UnFollow), Up-Down Arrow")
    ),

    RoodDBJC(
        fromTo = "23-May-2026",
        description = "Room database using hilt annotation, CRUD operation, Unit test cases and coding comment."
    ),

    DataStoreJC(
        fromTo = "23-May-2026",
        description = "Built on Kotlin coroutines and Flow, DataStore provides two different implementations: Proto DataStore, that stores typed objects (backed by protocol buffers) and Preferences DataStore, that stores key-value pairs."
    ),

    HiltJC(
        fromTo = "26-May-2026",
        description = "Hilt is a dependency injection (DI) framework based on Dagger support native platform. It is provider different types of annotation @AndroidEntryPoint, @HiltAndroidApp, @Inject, @ViewModelInject, @InstallIn, @ViewModelInject, @Singleton, @Provides, @Module, object class annotation etc."
    ),

    KoinJC(
        fromTo = "22-May-2026 - 19-Sep-2026",
        description = "Koin is a pure Kotlin framework, designed to be straight forward in terms of usage and execution. Uses the Service Locator pattern, which is an injection method at compile, realtime analysis and performance monitoring. Integrate with the Kotzilla Console to automatically spot ANRs, thread performance issues, and dependency complexity.",
        tags = listOf("Basic", "koin", "koin Work", "DI Types", "koinInject", "koinViewModel", "parameterOf", "Constructor DSL (Autowire)", "Annotations", "Navigation"),
        linkTags = listOf(
            "Basic" to Constants.KOIN_BASIC_URL,
            "Start" to Constants.KOIN_URL,
            "Annotations" to Constants.KOIN_ANNOTATIONS_URL,
            "Navigation" to Constants.KOIN_NAVIGATION_URL),
        bulletPoints = listOf("Basic - (Dependency Injection (DI) work, Use, Inversion of Control, How Koin Balances DI and SL, Choose Koin/Hilt, KSP, Why choose Koin?, Koin Work, Dependency Injection in Kotlin Multiplatform), Kotlin context parameters: not DI, but execution context")
    ),

    CleanArchitectureJC(
        fromTo = "22-May-2026 - 29-Sep-2026",
        description = "Clean Architecture aims to provide a clear separation of concerns, making the application easier to develop, test, and maintain.",
        tags = listOf("Solid Principles", "modularization", "Clean Architecture Layer (PRESENTATION LAYER, DOMAIN LAYER, DATA LAYER)", "overkill", "Use Case Patterns", "Repository Pattern", "DAO", "Repo To DAO", "Facade pattern", "Kotlin Mapper", "invoke()"),
        bulletPoints = listOf("Solid Principles - (Single Responsibility, Open/Closed, Liskov Substitution, Dependency Inversion)", "Monolithic Architecture", "modularization strategies", "Clean Architecture - (Core Principles, UI Layer, Domain Layer (framework-independent, Pure Kotlin, No Android imports, Model/Entities, Repository interface, UseCases/Interactors), Data Layer (Mapping DTO, Repositories (Local, Remote), Single-source-of-truth strategy, DataSource - (implementations of repositories)))", "Repositories interface / abstract (Choose abstract or interface - Separation of Concerns - Single Source of Truth - ViewModel call Repository - Repository hide its data sources - Decoupling)", "What’s the repository pattern? Why use it?", "Repository vs Use Cases — when is a use case overkill?", "Koin Clean Architecture", "Repositories interface / abstract (Choose abstract or interface - Separation of Concerns - Single Source of Truth - ViewModel call Repository - Repository hide its data sources - Decoupling)", "Facade pattern use clean architecture layer", "Handle Duplicate State Handling for UseCases", "Kotlin Mapper - (Kotlin AutoMapper, komm, Auto Mapping, Kraft)", "Stop Using Extension Functions for Domain Mapping in Clean Architecture - (Use explicit mapper classes or interfaces)")
    ),

    MVIJC(
        fromTo = "22-May-2026 - 14-Oct-2026",
        description = "MVI (Model-View-Intent) is a unidirectional data flow pattern and immutable state. The View sends Intents (user actions), the Model processes them and produces new State, and the View renders the State — making state predictable and testable.",
        tags = listOf("MVI", "Structure", "UiState", "UiIntent (sealed class, object)", "UiEffect", "MVI Counter", "Common ViewModel", "Combine", "MVI Works"),
        bulletPoints = listOf("MVI - (Intent → Reducer → State → UI)", "MVI Structure", "State Machine", "UiState - (Action → data class = flexible data holder for results/events)", "UiIntent - (Intent → sealed interface = closed set of possible user actions)", "UiEffect", "Adapting MVI for iOS", "Combine - (If you need to synchronise your data from different source into same state you should)")
    ),

    KToRJC(
        fromTo = "22-May-2026 - 25-Jun-2026",
        description = "Ktor is a multiplatform Asynchronous HTTP client which uses different plugins to extend its functionalities. To free up the space for threads and coroutines call.",
        tags = listOf("Interceptor", "Ghost Serializer", "BaseURL Platform Specific", "Close Connection", "Status Code", "Safe API", "File Upload"),
        bulletPoints = listOf("Three of these engines - (CIO, OkHttp, Darwin)", "Ghost Serializer - Ktor JSON Parsing 66% Faster with 50% Less Memory on KMP",  "Koin module create", "Network Speed Check", "BaseURL Platform Specific", "HttpRequestRetry", "DebugAntilog filter", "AutoCloseable", "Multiple Base URL", "Multiple Interceptor"),
       linkTags = listOf(
           "Socket" to Constants.KTOR_SOCKET_URL,
           "ktorfit" to Constants.KTOR_FIT_URL,
           "RPC" to Constants.RPC_URL
       )
    ),

    QuestionJC(
        fromTo = "28-May-2026 - 27-Jul-2026",
        description = "interview questions",
        linkTags = listOf(
            "Android Native +24" to "android_questions"
        )
    ),

    FilterCoroutines(
        fromTo = "22-May-2026",
        description = "combine is the backbone of modern ViewModels because Ul is snapshot-driven. A screen needs a full picture of the search query, selected filters, and data all at once."
    ),

    KoTestJC(
        fromTo = "22-May-2026",
        description = "Kotest is a multiplatform Kotlin testing framework featuring powerful assertions, property testing, and multiple expressive styles for any project.",
        bulletPoints = emptyList()
    ),

    //KMP
    BasicKMP(
        fromTo = "22-May-2026 - 31-Jul-2026",
        description = "The Kotlin Multiplatform technology aims to streamline the development process for cross - platform projects.",
        tags = listOf("Navigation", "Validation", "gradle.properties", "Cleanup command", "pod command", "pod delete command", "Shared resources", "Kotlin Multiplatform work", "Dispatchers", "Icon Generate", "File Reader"),
        bulletPoints = listOf("Quo Vadis Navigation", "FromZ Validation", "Validation koin", "ViewModelProvider & viewModelFactory", "shared resources across modules", "How does Kotlin Multiplatform work?", "Targets configure KMP", "Dispatchers using factory, interface and qualifier", "File Reader (Android, ioS, Wasm)", "Chart Library Links"),
        linkTags = listOf(
            "Validation" to KMM.KMP.FORMZ_VALIDATION_URL
        )
    ),

    Theme3KMP(
        fromTo = "21-May-2026",
        description = "Compose 1.6.3 latest version, material3 design likes Change theme, font, DP, String resource.",
        bulletPoints = emptyList()
    ),

    PluginKMP(
        fromTo = "21-May-2026",
        description = "Kotlin provides a language mechanism called expected/actual to access platform-specific APIs while developing common logic.",
        tags = listOf("expect", "actual", "UIKitView", "13 Approaches"),
        bulletPoints = listOf("shared module, ComposeUIViewController, UIKit, updateUIViewController, UIKitView, NativeViews for Android XML, low-level shared module, CValue", "How does Kotlin Multiplatform actually work under the hood?", "13 approaches to using expected and actual declarations")
    ),

    SharedPluginKMP(
        fromTo = "21-May-2026",
        description = "Google now officially recommends using Lifecycle-aware Multiplatform ViewModels in Kotlin Multiplatform projects.",
        tags = listOf("Approaches to bridge"),
        bulletPoints = listOf("Approaches to bridge - (KMP-NativeCoroutines, Manual wrapping, KMP-ObservableViewModel, swiftExport, koin Wrapper, SKIE (Swift Kotlin Interface Enhancer))", "Lifecycle Multiplatform ViewModels")
    ),

    PreferenceKMP(
        fromTo = "21-May-2026",
        description = "Kotlin library for Multiplatform apps, so that common code can persist key-value data. Settings interface has implementations on the Android, iOS, macOS, watchOS, tvOS, JS, JVM, and Windows platforms.",
        linkTags = listOf(
            "Preference" to KMM.KMP.SECURE_STORAGE_URL,
            "NSUserDefaults" to KMM.NS_USER_DEFAULTS_URL,
            "Log" to KMM.KMP.LOG_URL,
            "multiplatform-settings" to KMM.KMP.MULTIPLATFORM_SETTINGS_URL
        )
    ),

    ConstraintKMP(
        fromTo = "21-May-2026",
        description = "Constraint using Login and Create a new user design with image select from Gallery, both platform supported android and iOS."
    ),

    RealmDBKMP(
        fromTo = "21-May-2026",
        description = "Realm is a mobile database that runs directly inside phones, tablets or wearables.",
        linkTags = listOf(
            "Realm" to KMM.KMP.REALM_URL,
            "Room" to Constants.ROOM_KMP_URL,
            "Room Application" to "https://github.com/fluttertutorialin/RoomDatabase")
    ),

    FirebaseKMP(
        fromTo = "21-May-2026",
        description = "Firebase Generic all collection data, single collection data, first available data, insert, delete, check the document is exist, snapshotFlow."
    ),

    //KIDS
    BasicMathKids(
        fromTo = "10-Jun-2026",
        description = "Addition, Subtraction, Find/Identify Addition Keywords/Numbers Properties, Line Jumping - Forward, Backward (Back) and Ahead",
        linkTags = listOf(
            "Place Value & FaceValue" to Kids.Maths.PLACE_FACE_VALUE_URL,
            "Ordinal Number" to Kids.Maths.ORDINAL_NUMBER_URL,
        )
    ),

    BodyKids(
        fromTo = "24-May-2026 - 14-Oct-2026",
        description = "Our body has many parts. Each part has different name and function. Body part names are: head, ear, eye, nose, lip, mouth, neck, shoulder, elbow, finger, chest, arm, hand, stomach, knee, leg, foot, toe.",
        tags = listOf("Sense Organs", "Internal organs", "Organ System"),
        bulletPoints = listOf("Body, Sweat (perspiration), Eyes, Ears, Nose, Skin, Tongue, Mouth, Head, Neck, Stomach / Torso, Kidney, Hand, Leg", "Internal organs: (Brain, Heart, Lungs, Stomach, Bones and Muscles", "Habit Tips", "Organ System (Respiratory, Digestive, Circulatory, Nervous, Skeletal, Muscular, Excretory, Reproductive)"),
        linkTags = listOf(
                "Human Body (Grade 3)" to Kids.Grade3.EVS.HUMAN_BODY_URL
        )
    ),

    FamilyKids(
        fromTo = "22-Jun-2026",
        description = "A family is a group of people who love and care for each other. We live together and help each other!",
        tags = listOf("Family", "Types of Families", "Masculine", "Feminine", "Nouns")
   ),

    EarthKids(
        fromTo = "10-Jun-2026",
        description = "The earth is the third planet from the Sun. We live in a wonderful world called the Earth. It provides us with habitat, water, food, etc. World Earth Day is celebrated on 22nd April every year.",
        tags = listOf("Earth", "Land", "plains", "hills", "mountains", "Valley", "Water", "Air"),
        bulletPoints = listOf("About Our Earth", "Land", "Water - (Ponds, Lakes, Rivers, Seas and Oceans)", "Air - (Natural and Man-made things)")
    ),

    WaterKids(
        fromTo = "24-May-2026 - 23-Sep-2026",
        description = "Water is a clear liquid. We drink water every day. All living things, such as people, plants and animals, need water to live. Without water, living things would not exist.",
        tags = listOf("Needs Water", "Properties", "Use", "Source", "Storage", "Save", "Quiz", "General Knowledge"),
        bulletPoints = listOf("Who needs Water?", "Properties of Water", "Use Water", "Sources of Water - (Natural and Man-Made), Storage of Water, Save of Water", "Where we use water"),
        linkTags = listOf(
            "Plants" to Kids.EVS.PLANTS_URL,
            "Plants Make Food" to Kids.EVS.PLANTS_MAKE_FOOD_URL,
            "Agriculture India" to Kids.EVS.AGRICULTURE_INDIA_URL,
            "River System" to Kids.EVS.RIVER_SYSTEM_URL
        )
    ),

    AirKids(
        fromTo = "24-May-2026 - 19-Aug-2026",
        description = "Air is present all around us. It has no colour and we cannot see it but we can feel it when it moves. All living things need air.",
        tags = listOf("About Air", "Types", "Use", "Air Pollution", "Clean Air", "Quiz"),
        bulletPoints = listOf("About Air - invisible (can not see), colorless, Not see, Not Touch", "Types of Moving Air, Use of Air, Keeping Air Clean")
    ),

    SkyKids(
        fromTo = "10-Jun-2026",
        description = "The sky is the atmosphere and outer space visible from Earth's surface, appearing blue on clear days and dark at night.",
        bulletPoints = listOf("At Night / Day Sky", "Clouds", "Moon", "Stars", "Sun", "Rainbow (ROY G BIV or VIBGYOR)", "Solar System"),
        linkTags = listOf(
            "Solar System" to Kids.EVS.SOLAR_SYSTEM_URL
        )
    ),

    WeatherKids(
        fromTo = "10-Jun-2026",
        description = "Weather",
        tags = buildList { listOf("Weather", "Seasons", "Water cycle (hydrologic cycle)", "Layers of the Earth's atmosphere", "Measure weather") },
        bulletPoints = listOf("Weather", "Seasons", "Water cycle (hydrologic cycle) - (Evaporation, Condensation, Precipitation, Collection)", "Layers of the Earth's atmosphere (Troposphere, Stratosphere, Mesosphere, Thermosphere, Exosphere)")
    ),

    LivingDifferentSeasonsKids(
        fromTo = "19-Oct-2026",
        description = "Living in Different Seasons",
        tags = listOf("Weather", "Seasons", "loo")
    ),

    StoriesKids(
        fromTo = "24-May-2026",
        description = "The Fox and the Grapes, The Golden Egg, The Ants and the Grasshopper, Two Cats and the Monkey (Two cats were fighting food), Rain Day, The Hare and the Tortoise and The Elephant and the Ant.",
        bulletPoints = listOf("The Fox and the Grapes", "The Golden Egg", "The Ants and the Grasshopper", "Two Cats and the Monkey (Two cats were fighting food)", "Rain Day", "The Hare and the Tortoise", "The Elephant and the Ant")
    ),

   AnimalsKids(
        fromTo = "24-May-2026 - 08-Sep-2026",
        description = "Animals are found almost everywhere on Earth. Animals and their surroundings. Do all animals look same? No. They are of different shapes and sizes (Animals come in all shapes and sizes!).",
        tags = listOf("Eat", "Help", "Live", "Puppies Name", "Sound", "Actions"),
        bulletPoints = listOf("How animals help us?", "Taking Care of Animals", "Eat - (Herbivores, Carnivores, Omnivores)", "Extinct and Endangered Animals", "Domestic Animals, Pets Animals, Wild Animals, Dead Animals", "Where Animals Live")
    ),

    IndianFestivalKids(
        fromTo = "24-May-2026",
        description = "Religious festivals are special days celebrated by people of a particular religion.",
        tags = listOf("Festival", "Types of Festival", "Independence Day", "26th January", "Mahatma Gandhi", "Dr. Sarvepalli Radhakrishna (Teachers Day)", "Children's Day", "Dussehra", "Diwali", "Christmas", "Holi", "Gurupurab", "Ganesh Chaturthi", "Pongal", "Makar Sankranti", "Bihu", "Onam", "Lohri"),
        bulletPoints = listOf("Types of Festival - (National Festival, Religious Festival, Harvest Festival)")
    ),

    VisitPlacesKids(
        fromTo = "29-Jun-2026",
        description = "We are surrounded by many beautiful places that we can visit. Places that are built by humans are called man-made places. Places that are found in nature are called natural places.",
        bulletPoints = listOf("Natural places", "Man-made places", "Historical places"),
        linkTags = listOf(
            "Useful Places" to Kids.EVS.USEFUL_PLACES_URL
        )
    ),

    OurHelperKids(
        fromTo = "12-Jun-2026",
        description = "We cannot do all our work alone. Besides our family, we depend on many other people around us in our day-to-day life. These people help us and make our lives comfortable.",
        tags = listOf("Community Helpers", "Transport", "Teacher", "Doctor", "Police", "Postman", "Cobbler", "Tailor", "Barber", "Sweeper", "Watchman", "Farmer", "Soldier", "Pilot", "Carpenter", "Chef", "Waiter", "Driver", "Plumber", "Electrician", "Scientist", "Washerman", "Greengrocer", "Milkman", "Delivery person", "Traffic police", "Firefighter", "Chemist"),
        bulletPoints = listOf("Community Helpers")
    ),

    CommunicationKids(
        fromTo = "12-Jun-2026",
        description = "Communication is the sharing of thoughts, ideas and information with others.",
        tags = listOf("Types of Communication"),
        bulletPoints = listOf("Types of Communication - (Private communication, Mass communication)")
    ),

    ShelterKids(
        fromTo = "19-Jul-2026",
        description = "A shelter is a covered place, which provides protection to humans, animals and birds from their surroundings.",
        tags = listOf("Types of Houses", "Permanent houses", "Temporary houses", "Who Build House")
    ),

    OurSchoolKids(
        fromTo = "13-Aug-2026 - 19-Aug-2026",
        description = "Our school has different areas which we use to do different things.",
        tags = listOf("Classroom", "Teacher", "Library", "Who work people")
    ),

    RideToReader2Kids(
        fromTo = "27-May-2026 - 13-Oct-2026",
        description = "",
        linkTags =
            listOf(
                "Now That I Can Read" to RideToRider.Second.CAN_READ_URL,
                "Wiggly Tooth" to RideToRider.Second.WIGGLY_TOOTH_URL,
                "Mason" to RideToRider.Second.MASON_URL,
                "Tucket the Bucket" to RideToRider.Second.TUCKET_BUCKET_URL,
                "Little Turtle" to RideToRider.Second.LITTLE_TURTLE_URL,
                "Magic Playhouse" to RideToRider.Second.MAGIC_PLAYHOUSE_URL,
                "Story" to RideToRider.Second.STORY_URL,
                "Double Trouble" to RideToRider.Second.DOUBLE_TROUBLE_URL,
                "A good Play" to RideToRider.Second.GOOD_PLAY_URL,
                "Comprehension" to RideToRider.Second.COMPREHENSION_URL,
                "English 1 (Test Paper)" to TestPaper.ENGLISH_1_URL
            )
    ),

    DictationKids(
        fromTo = "22-May-2026 - 12-Jul-2026",
        description = "Round 1 - 20, Round 2 - 20, Round 3 - 50",
        tags = listOf("The Picnic Day", "The Busy Ant", "The Rainy Morning", "The Helpful Girl"),
        linkTags = listOf(
            "Passage" to RideToRider.Second.PASSAGE_URL
        )
    ),

    //Flipkart
    LabelCropping(
        fromTo = "13-Oct-2026",
        description = "Crop pdf shipping labels to remove the invoice section, sort by SKU, and download a clean print-ready PDF for packing.",
        tags = listOf("Label Cropping", "Free", "Sorting", "Drag and Drop SKU", "Label Preview", "No signup required")
     ),

    KitchenTrolleyListingFlipkart(
        fromTo = "26-May-2026",
        description = "Metal Square High Quality Kitchen Trolley with Wheels and Vibrant kitchen organizer.",
        tags = listOf("Metal", "Storage", "Shape", "Layer - (2,3,4,5)"),
        bulletPoints = listOf("Storage - (kitchen, utensils, groceries, office Documents)", "Design - (Round, Square, Hexagon, Captual, Line Horizontal)")
    ),
    WardrobePlasticListingFlipkart(
        fromTo = "26-May-2026",
        description = "2/3/4/5/6 (Only one select) Layer Collapsible PP Wardrobe for Clothes & DIY (Do-It-Yourself)",
        tags = listOf("Plastic", "Storage", "Product Specification", "Key Features", "About"),
        bulletPoints = listOf("Storage - (Luggage, Books, Official Documents, Space Save)")
     ),

    StepLadderListingFlipkart(
        fromTo = "26-May-2026",
        description = "Mild Steel Multipurpose Climb Swift (3,4,5,6,7) - Step Foldable Ladder"
    ),

    ClothDryerListingFlipkart(
        fromTo = "5-Jun-2026",
        description = "Portable Folding Electric Clothes Dryer Rack with Heating Function"
    ),

    PannerPressMakerListingFlipkart(
        fromTo = "19-Jun-2026",
        description = "Smooth stainless steel surface prevents sticking; dishwasher-safe and effortless to clean after use."
    ),

    WallMountedListingFlipkart(
        fromTo = "19-Jun-2026",
        description = "Mirror Door with Hidden Storage Front mirror door provides a clear reflection your items. Ideal for storing medicines, cosmetics, shampoo, toiletries, laundry detergent, and toilet cleaning products. Also features hooks for hanging towels.  The middle part has a large capacity to store towels, toiletries, cosmetics, and so on. The top edge is smooth and round designed to avoid unnecessary injury by accident. The pull-out main drawer offers a section that's large enough for your toilet rolls and keeps them dry."
    ),

    ChoppingBoardFlipkart(
        fromTo = "12-Aug-2026",
        description = "Stainless Steel Chopping Board (Vegetable, Fruit Cutting, Meat, Fruits, Kneeding, Cake Prep).",
    ),
}

